import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
    name: 'filter',
})
export class FilterPipe implements PipeTransform {

    transform<T>(items: T[], fn: (x: T, i: number, arr: T[]) => boolean) {
        return items.filter(fn);
    }
}
